import Loadable from '../../components/loadable';

const CheckedInAttendance = Loadable({
  loader: () => import('../../pages/dashboard/attendance/checked_in_attendance'),
  type: 'block',
});

angular.module('gym').value('CheckedInAttendance', CheckedInAttendance);
